import { RowItemType, Section, UIElementType, UIItem } from '../../models/models';
import { LocationCardPermissions } from '../../reducers';

export const otherMonitorsInfo = (monitorSeries: string, permissions: LocationCardPermissions): Section => {
    return {
        info: {
            id: 'other-monitors-info',
            title: monitorSeries,
            displayTitle: true,
            expandable: true,
            expanded: false,
            panelClass: !permissions.isMonitorEditor ? 'disable-field' : '',
        },
        rows: [
            // Not supported message row with icon and text
            {
                info: {
                    id: 'not-supported-row',
                    panelClass: 'triton-border text-bottom-space display-content flex gap-3',
                },
                items: [
                    // Clear icon
                    {
                        id: 'clear-icon',
                        type: RowItemType.UI,
                        uiType: UIElementType.Icon,
                        iconName: 'clear',
                        panelClass: 'clear-icon',
                    },
                    {
                        id: 'not-supported-section',
                        type: RowItemType.Section,
                        section: {
                            info: {
                                id: 'not-supported-section-id',
                                title: '',
                                displayTitle: false,
                                expandable: false,
                                panelClass: 'flex flex-column',
                            },
                            rows: [
                                {
                                    info: {
                                        id: 'not-supported-heading-row',
                                        panelClass: '',
                                    },
                                    items: [
                                        {
                                            id: 'not-supported-heading',
                                            type: RowItemType.UI,
                                            uiType: UIElementType.Text,
                                            label: 'ADD_EDIT.NOT_SUPPORTED',
                                            panelClass: 'input-text',
                                        },
                                    ],
                                },
                                {
                                    info: {
                                        id: 'not-supported-description-row',
                                        panelClass: 'flex gap-1',
                                    },
                                    items: [
                                        {
                                            id: 'not-supported-description',
                                            type: RowItemType.UI,
                                            uiType: UIElementType.Text,
                                            label: 'ADD_EDIT.UNFORTUNATELY_ACTIVATION',
                                            panelClass: 'cutomer-text',
                                        },
                                        // Supported in Prism text
                                        {
                                            id: 'supported-in-prism',
                                            type: RowItemType.UI,
                                            uiType: UIElementType.Text,
                                            label: 'ADD_EDIT.SUPPORTED_IN_PRISM',
                                            panelClass: 'cutomer-text',
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },

            {
                info: {
                    id: 'divider-row',
                    panelClass: 'divider margin-1-0',
                },
                items: [
                    {
                        id: 'divider',
                        type: RowItemType.UI,
                        uiType: UIElementType.Divider,
                        name: 'divider',
                        dividerStyle: 'solid',
                        dividerThickness: 1,
                        dividerColor: '#e0e0e0',
                        panelClass: 'divider-content',
                    },
                ],
            },

            // Customer information heading row
            {
                info: {
                    id: 'customer-info-heading-row',
                    panelClass: '',
                },
                items: [
                    // Customer information heading
                    {
                        id: 'customer-info-heading',
                        type: RowItemType.UI,
                        uiType: UIElementType.Text,
                        label: 'ADD_EDIT.CUSTOMER_INFORMATION',
                        panelClass: 'h3',
                    },
                ],
            },

            // Phone numbers row
            {
                info: {
                    id: 'phone-numbers-row',
                    panelClass: 'display-content flex',
                },
                items: [
                    // US Phone button
                    {
                        id: 'us-phone-button',
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        name: 'us-phone',
                        label: '256-430-3366',
                        iconName: 'phone',
                        suffixText: 'ADD_EDIT.INSIDE_US',
                        suffixTextClass: 'cutomer-text',
                        panelClass: 'phone-icon customer-details',
                        events: {
                            onClick: () => [],
                        },
                    },
                    // Toll free phone button
                    {
                        id: 'tollfree-phone-button',
                        type: RowItemType.UI,
                        uiType: UIElementType.Button,
                        iconName: 'phone',
                        suffixText: 'ADD_EDIT.TOLL_FREE',
                        suffixTextClass: 'cutomer-text',
                        name: 'tollfree-phone',
                        label: '877-237-9585',
                        panelClass: 'phone-icon',
                        events: {
                            onClick: () => [],
                        },
                    },
                ],
            },
        ],
    };
};
